import axios from 'axios'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import { GetStaticProps } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { Converters } from 'services/Converters'

type Props = {
  page: any
}

export default function LimitedTimeLaunchPromoPage(props: Props) {
  const attr = props.page.data.attributes
  return (
    <Fragment>
      <Head>
        <title>LIMITED TIME LAUNCH PROMO</title>
      </Head>
      <div id="limited-time">
        <h2 id="limited-time-launch-promo">{attr.title}</h2>
        <p>
          <em>{attr.description}</em>
        </p>
      </div>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try{
    const page = await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/launch-promo',
    }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))
    return { props: { page }, revalidate: Env.PropsRevalidateTime }
  }catch{
    return {
      notFound: true
    }
  }
}
